import { MaintenanceWindowFormPatchSpecificsWebComponent } from './component/MaintenanceWindowFormPatchSpecificsWebComponent';
import { WEB_COMPONENT_MAINTENANCE_WINDOW_FORM_PATCH_SPECIFICS } from '../../webcomponents.constants';

export { MaintenanceWindowFormPatchSpecificsWebComponent };

window.customElements.define(
  WEB_COMPONENT_MAINTENANCE_WINDOW_FORM_PATCH_SPECIFICS,
  MaintenanceWindowFormPatchSpecificsWebComponent
);
